import GiftCard1 from './GiftCard1';

export default GiftCard1;
